
import { Mixins, Component, Prop } from 'vue-property-decorator';
import BsMixin from '@/views/Home/mixins/bsMixin';
import tModal from '@/components/Modal/index.vue';

@Component({
  components: {
    tModal,
  },
})
export default class AssetRemove extends Mixins(BsMixin) {
  @Prop({
    required: true,
  }) visible!: boolean;

  @Prop({
    required: true,
  }) title!: string;

  @Prop({
    required: true,
  }) datas!: any;

  @Prop({
    required: true,
  }) close!: Function;

  public $refs!: {
    content: HTMLElement,
  }

  mounted() {
    this.initBS(this.$refs.content);
  }

  handleClickChapter(id: string, cid: string) {
    this.$router.push({
      name: 'course/chapter',
      params: {
        pid: Base64.encode(id),
        cid,
        type: 'Question',
      },
    });
  }
}
